import { useEffect, useState } from 'react';
import $ from 'jquery';

import AOS from 'aos';
import 'aos/dist/aos.css';

// Trasnlation
import './i18n';
import { useTranslation } from 'react-i18next';

// Store
import Store from './services/store';
//componentes
import FooterServicios from './components/landings/servicios/footer_servicios';
import HeaderServicios from './components/landings/servicios/header_servicios';
import RoutesLandings from './routerLanding';

function AppLServicios() {
	const [sended, setSended] = useState(false);

	const { i18n } = useTranslation();

	const initLang = () => {
		if (localStorage.getItem('lng')) {
			i18n.changeLanguage(localStorage.getItem('lng'));
		} else {
			window.localStorage.setItem('lng', 'es');
			i18n.changeLanguage('es');
		}
	};
	const setSendede = () => {
		setSended(true);
	};

	return (
		<Store>
			<div className='App' onLoad={initLang}>
        <HeaderServicios/>

        <RoutesLandings sended={sended} setSended={setSendede}/>
        
        <FooterServicios/>
			</div>
		</Store>
	);
}

export default AppLServicios;
